import { AysCodeCodingSystem } from '@bindoc-projects/code-domain-lib';

export class BdAdministrativeDistrictStore {
  constructor(private readonly _baseUrl: string) {}

  public index(): string {
    return `${this._baseUrl}/administrative_districts/`;
  }

  public casesAll(codingSystem: AysCodeCodingSystem): string {
    return `${this.index()}cases/${codingSystem}/all`;
  }

  public byAdministrativeDistrictId(adId: string): string {
    return `${this.index()}${adId}`;
  }

  public postalCodes(): string {
    return `${this.index()}postal-codes`;
  }

  public centerPoints(): string {
    return `${this.index()}center-points`;
  }
}
